<template>
    <div
        id="OrgViewMemberButtons"
        class="flex w-full flex-col items-center gap-2 whitespace-nowrap sm:w-fit sm:flex-row"
    >
        <CButton
            v-if="isOrgIdView"
            full
            icon="settings"
            :to="{
                name: 'profile-orgs-id',
                params: { id: org.id }
            }"
            variant="primary-150"
        >
            Spravovať profil
        </CButton>

        <CButton
            v-else
            full
            icon="edit"
            :to="{
                name: 'profile-orgs-edit-id',
                params: { id: org.id }
            }"
            variant="primary-150"
        >
            Upraviť profil
        </CButton>

        <CButton
            full
            icon="activity"
            :to="{
                name: 'profile-activity',
                query: {
                    org: org.id,
                    status: 'waiting,confirm,active,job_draft'
                }
            }"
            variant="primary-150"
        >
            Aktivity
        </CButton>

        <CButton
            full
            icon="open-in-new-tab"
            :to="{
                name: 'orgs-id',
                params: { id: org.slug }
            }"
        >
            Zobraziť profil
        </CButton>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'

import type { Org } from '#shared/types/Org'

const props = defineProps<{
    org: Org
}>()

const route = useRoute()

const isOrgIdView = computed(() => {
    return route.name === 'orgs-id'
})
</script>